import { DialogHandler, Dropdown } from "cakemail-ui-components/lib/react";
import { Translate, I18n } from "react-redux-i18n";
import { sendZendeskRequestService } from "assets/js/services/hiddenService";
import React from "react";
import { isOrganization, isPartner, openBillingPortal } from "utils/apiUtils";
import store from "assets/js/store";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";

export const SUPPORT_TYPE = {
	UPGRADE: "upgrade",
	DOWNGRADE: "downgrade",
	SUPPORT: "support",
};

/**
 * @param type enum["upgrade", "downgrade", "support"]
 * @param message string
 * @param strings
 **/
export function showZendeskSupportDialog(type, message = "", strings = { title: null, text: null }) {
	if (isPartner(true)) {
		return;
	}

	let title = <Translate value="app-plan-upgrade-dialog-title" />;
	let text = <Translate value="app-plan-upgrade-dialog-text" />;

	if (type === SUPPORT_TYPE.DOWNGRADE) {
		title = <Translate value="app-plan-dialog-stripe-downgrade-title" />;
		text = <Translate value="app-plan-dialog-stripe-downgrade-text" />;
	} else if (type === SUPPORT_TYPE.SUPPORT) {
		title = <Translate value="app-general-support-dialog-title" />;
		text = <Translate value="app-general-support-dialog-text" />;
	}

	if (strings.title) {
		title = <Translate value={strings.title} />;
	}

	if (strings.text) {
		text = <Translate value={strings.text} />;
	}

	DialogHandler.hide();
	DialogHandler.show({
		title: title,
		content: <p>{text}</p>,
		primaryBtnText: <Translate value="app-plan-upgrade-zendesk-send" />,
		primaryBtnOnClick: () => {
			sendZendeskRequestService(
				{
					content: {
						type: type,
						message: message,
					},
				},
				() => {
					let event = SEGMENT_EVENTS.SUPPORT_REQUESTED;
					if (type === SUPPORT_TYPE.UPGRADE) {
						event = SEGMENT_EVENTS.PLAN_UPGRADE_INITIATED;
					} else if (type === SUPPORT_TYPE.DOWNGRADE) {
						event = SEGMENT_EVENTS.PLAN_DOWNGRADE_INITIATED;
					}

					trackSegmentEvent(event, {
						message: message,
					});

					DialogHandler.show({
						type: "success",
						title: <Translate value="app-general-request-submited" />,
					});
				},
				(msg) => {
					let message = "app-plan-upgrade-dialog-error";
					if (typeof msg === "string") {
						message = msg;
					}

					DialogHandler.show({
						type: "error",
						title: <Translate value={message} />,
					});
				}
			);
			DialogHandler.hide();
		},
		secondaryBtnText: <Translate value="app-general-cancel" />,
	});
}

export function showStripeCurrencySelection(priceId) {
	DialogHandler.hide();
	let selectedCurrency = "USD";

	let currencies = store.getState().brand?.config?.supported_currencies;

	if (!currencies) {
		currencies = ["USD"];
	}
	selectedCurrency = currencies[0];

	DialogHandler.show({
		className: "stripeCurrencyDialog",
		title: <Translate value="app-plan-dialog-stripe-title" />,
		content: (
			<div className="stripeCurrencyDialog">
				<p>
					<Translate value="app-plan-dialog-stripe-text" dangerousHTML />
				</p>

				<Dropdown
					type="custom"
					label={I18n.t("app-plan-currency-select-label")}
					placeholder={I18n.t("app-plan-currency-select-label")}
					options={currencies.map((currency) => {
						return {
							label: currency,
							value: currency,
							selected: currency === selectedCurrency,
						};
					})}
					onChange={(e, input, option) => {
						selectedCurrency = option.value;
					}}
				/>
			</div>
		),
		primaryBtnText: <Translate value="app-plan-currency-select-btn" />,
		primaryBtnOnClick: () => {
			openBillingPortal(null, priceId);
			DialogHandler.hide();
		},
		secondaryBtnText: <Translate value="app-general-cancel" />,
	});
}
